var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8c0-4.25-3.5-7.75-7.75-7.75C3.719.25.25 3.75.25 8A7.75 7.75 0 0 0 8 15.75c4.25 0 7.75-3.469 7.75-7.75zM8 9.563c.781 0 1.438.656 1.438 1.438 0 .813-.656 1.438-1.437 1.438-.812 0-1.437-.625-1.437-1.437 0-.781.625-1.437 1.438-1.437zM6.625 4.406C6.594 4.188 6.781 4 7 4h1.969c.219 0 .406.188.375.406l-.219 4.25C9.094 8.875 8.938 9 8.75 9H7.219c-.187 0-.344-.125-.375-.344l-.219-4.25z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/exclamation-mark.381e7b02fdc62cd2d7214239c4b37c70.svg";
export { ForwardRef as ReactComponent };